// extracted by mini-css-extract-plugin
export default {"inventory":"InventoryList_inventory__xBnmg","inventoryEntry":"InventoryList_inventoryEntry__qu0ub"};